import { DayOfWeek, TimeRangeInfo } from '@leid/api-locations'

const roundToHours = (hours: number, minutes: number): number => {
  return minutes !== 0 ? hours + 1 : hours
}

const isInPeriod = (hour: number, fromHour: number, toHour: number): boolean => {
  const isInPeriod = hour >= fromHour && hour <= toHour
  return isInPeriod
}

export const checkTimeRange = (hour: number, openingHours: TimeRangeInfo[], isReturn: boolean): boolean => {
  const results = []
  for (const openingHour of openingHours) {
    const fromHour = roundToHours(openingHour.from.hours, openingHour.from.minutes)
    let toHour = roundToHours(openingHour.to.hours, openingHour.to.minutes)
    if (!isReturn) {
      toHour -= 1
    }

    results.push(isInPeriod(hour, fromHour, toHour))
  }

  if (results.length === 0) {
    return true
  }

  return results.some((s) => s === true)
}

export const getDayOfWeek = (date: Date): DayOfWeek => {
  const dayNumber = date.getDay()

  switch (dayNumber) {
    case 0:
      return DayOfWeek.SUNDAY
    case 1:
      return DayOfWeek.MONDAY
    case 2:
      return DayOfWeek.TUESDAY
    case 3:
      return DayOfWeek.WEDNESDAY
    case 4:
      return DayOfWeek.THURSDAY
    case 5:
      return DayOfWeek.FRIDAY
    case 6:
      return DayOfWeek.SATURDAY
    default:
      return DayOfWeek.MONDAY
  }
}
